import type { CountryCode } from "@config/site/types";

// DHL Packstation and Postfiliale wording, so only the markets that use it.
const MARKETS_WITH_PARCEL_LOCKER_CHECK: CountryCode[] = ["DE"];

// Whole terms only, so "Packstation105" matches but a street like "Postfilialenweg" does not.
const PARCEL_LOCKER_PATTERN =
    /\b(?:pack[\s-]?station|post[\s-]?station|post[\s-]?filiale|post[\s-]?nummer)(?![a-zäöüß])/i;

export const isParcelLockerAddress = (
    streetName: string | undefined,
    country: CountryCode
): boolean =>
    MARKETS_WITH_PARCEL_LOCKER_CHECK.includes(country) &&
    PARCEL_LOCKER_PATTERN.test(streetName ?? "");
